
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const imageData = {
2020: [
    { src: "/assets/2020_1.jpg", name: "", description: "" },
    { src: "/assets/2020_2.jpg", name: "", description: "" },
    { src: "/assets/2020_3.jpg", name: "", description: "" },
    { src: "/assets/2020_4.jpg", name: "", description: "" },
    { src: "/assets/2020_5.jpg", name: "", description: "" },
    { src: "/assets/2020_6.jpg", name: "", description: "" },
    { src: "/assets/2020_7.jpg", name: "", description: "" },
    { src: "/assets/2020_8.jpg", name: "", description: "" },
    { src: "/assets/2020_9.jpg", name: "", description: "" },
    { src: "/assets/2020_10.jpg",name:"",  description: "" },
    { src: "/assets/2020_11.jpg",name: "", description: "" },
    { src: "/assets/2020_12.jpg", name: "", description: "" },
  ],
  2021: [
    { src: "/assets/2021_1.JPEG", name: "Job Fair", description: "Opening of the annual job fair." },
    { src: "/assets/2021_2.JPEG", name: "Job Fair", description: "Opening Speech of the annual job fair." },
    { src: "/assets/2021_3.jpg", name: "Job Fair", description: "Candidates waiting area." },
    { src: "/assets/2021_4.JPG", name: "Job Fair", description: "Employers engaging with candidates." },
    { src: "/assets/2021_5.jpg", name: "Job Fair", description: "Candidates visiting booths." },
    { src: "/assets/2021_6.jpg", name: "Job Fair", description: "Candidates engaging with employers." },
    { src: "/assets/2021_7.jpg", name: "Job Fair", description: "Candidates engaging with employers.." },
    { src: "/assets/2021_8.jpg", name: "Job Fair", description: "Employer networking conference." },
    { src: "/assets/2021_9.jpg", name: "Job Fair", description: "Employer networking conference." },
    { src: "/assets/2021_10.jpg", name: "Job Fair", description: "Press Conference" },
    { src: "/assets/2021_11.jpg", name: "Job Fair", description: "Stakeholders and guests visiting booths." },
  ],
  2022: [
    { src: "/assets/2022_1.jpg", name: "Job Fair", description: "HR conference." },
    { src: "/assets/2022_2.jpg", name: "Job Fair", description: "HR conference." },
    { src: "/assets/2022_3.jpg", name: "Job Fair", description: "HR conference." },
    { src: "/assets/2022_4.jpg", name: "Job Fair", description: "Opening of the annual job fair." },
    { src: "/assets/2022_5.jpg", name: "Job Fair", description: "Candidates engaging with employers." },
    { src: "/assets/2022_6.jpg", name: "Job Fair", description: "Gate of the job fair." },
    { src: "/assets/2022_7.jpg", name: "Job Fair", description: "Candidates applying at employer's booth." },
    { src: "/assets/2022_8.jpg", name: "Job Fair", description: "Candidates engaging with employers." },
    { src: "/assets/2022_9.jpg", name: "Job Fair", description: "Team celebrating the end of the job fair." },
    { src: "/assets/2022_10.jpg", name: "Job Fair", description: "Opening of a job fair event." },
    { src: "/assets/2022_11.jpg", name: "Job Fair", description: "Candidates engaging with each other." },
    { src: "/assets/2022_12.jpg", name: "Job Fair", description: "Opening of the Job fair event." },
  ],
  2023: [
    { src: "/assets/g1.jpg", name: "Job Fair", description: "Engagement session." },
    { src: "/assets/g2.jpg", name: "Job Fair", description: "Candidates at the registration of the national career expo. " },
    { src: "/assets/g3.jpg", name: "Job Fair", description: "Networking session at the career expo." },
    { src: "/assets/g4.jpg", name: "Job Fair", description: "Stakeholders at the opening of the national career expo." },
    { src: "/assets/g5.jpg", name: "Job Fair", description: "Networking session at the career expo." },
    { src: "/assets/g6.jpg", name: "Job Fair", description: "Networking session at the career expo." },
    { src: "/assets/g7.jpg", name: "Job Fair", description: "Candidates applying at employer's booth." },
    { src: "/assets/g8.jpg", name: "Job Fair", description: "Candidates applying at employer's booth." },
  ],
  2024: [
    { src: "/assets/img11.jpg", name: "Career Expo", description: "Opening of the 5th National Career Expo." },
    { src: "/assets/img4.jpg", name: "Career Expo", description: "Opening of the 5th National Career Expo." },
    { src: "/assets/campaignwku.png", name: "Campaign", description: "Orientation session of Dereja interventions." },
    { src: "/assets/hawassa.png", name: "Milk-Run Job Fair",description: "Opening Ceremony" },
    { src: "/assets/Nationalcareerexpo.jpg", name: "National Career Expo",description: "Candidate interviewing at the national career expo." },
    { src: "/assets/bss.jpg", name: "Career Expo", description: "Candidates applying at employer's booth." },
    { src: "/assets/img6.jpg", name: "Campaign", description: "Orientation session of Dereja interventions." },
    { src: "/assets/img10.jpg", name: "Graduate Trainee program", description: "Welcoming ceremony for Dereja graduate trainee program candidate's ." },
    { src: "/assets/img12.jpg", name: "MOU", description: "Signatory with Ministry of Education." },
    { src: "/assets/img13.jpg", name: "Entrepreneurship Week ", description: "Hawassa university entrepreneurship week training." },
    { src: "/assets/daap4.jpg", name: "DAAP", description: "Energizer activity on the training session." },
  ],
};

const years = Object.keys(imageData).map((y) => parseInt(y));
const IMAGES_PER_PAGE = 6;

export default function Gallery() {
  const [currentYearIndex, setCurrentYearIndex] = useState(years.length - 1);
  const [currentImagePage, setCurrentImagePage] = useState(0);

  const currentYear = years[currentYearIndex];
  const fullImages = imageData[currentYear].slice(0, 15);
  const totalPages = Math.ceil(fullImages.length / IMAGES_PER_PAGE);

  const paginatedImages = fullImages.slice(
    currentImagePage * IMAGES_PER_PAGE,
    (currentImagePage + 1) * IMAGES_PER_PAGE
  );

  const handleYearChange = (index) => {
    setCurrentYearIndex(index);
    setCurrentImagePage(0);
  };

  return (
    <div>
      <motion.section
        className="relative text-center bg-gradient-to-r from-red-400 via-yellow-500 to-orange-600 text-white py-1"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h1 className="text-4xl font-bold mb-4 pt-6">Gallery</h1>
        <p className="text-lg max-w-3xl mx-auto mb-2">
          Explore our journey through this visual gallery, capturing moments
          from our work, travels, and experiences abroad.
        </p>
      </motion.section>

      <section className="bg-white py-6">
        <div className="flex justify-center items-center gap-4">
          <button
            onClick={() =>
              setCurrentYearIndex((prev) => (prev > 0 ? prev - 1 : prev))
            }
            className={`p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition ${
              currentYearIndex === 0 ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={currentYearIndex === 0}
          >
            <ArrowBackIosIcon fontSize="small" />
          </button>

          {years.map((year, index) => (
            <button
              key={year}
              onClick={() => handleYearChange(index)}
              className={`text-lg font-semibold px-4 py-2 rounded-full transition ${
                year === currentYear
                  ? "bg-orange-500 text-white shadow"
                  : "text-gray-700 hover:bg-gray-200"
              }`}
            >
              {year}
            </button>
          ))}

          <button
            onClick={() =>
              setCurrentYearIndex((prev) =>
                prev < years.length - 1 ? prev + 1 : prev
              )
            }
            className={`p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition ${
              currentYearIndex === years.length - 1
                ? "opacity-50 cursor-not-allowed"
                : ""
            }`}
            disabled={currentYearIndex === years.length - 1}
          >
            <ArrowForwardIosIcon fontSize="small" />
          </button>
        </div>
      </section>

      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-6 lg:px-16">
          <div className="flex justify-between items-center mb-6">
            <button
              onClick={() =>
                setCurrentImagePage((prev) => (prev > 0 ? prev - 1 : prev))
              }
              className={`p-2 rounded-full bg-gray-300 hover:bg-gray-400 ${
                currentImagePage === 0 ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={currentImagePage === 0}
            >
              <ArrowBackIosIcon />
            </button>

            <span className="text-gray-700 font-semibold">
              Page {currentImagePage + 1} of {totalPages}
            </span>

            <button
              onClick={() =>
                setCurrentImagePage((prev) =>
                  prev < totalPages - 1 ? prev + 1 : prev
                )
              }
              className={`p-2 rounded-full bg-gray-300 hover:bg-gray-400 ${
                currentImagePage === totalPages - 1
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
              disabled={currentImagePage === totalPages - 1}
            >
              <ArrowForwardIosIcon />
            </button>
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={currentImagePage}
              className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.5 }}
            >
             
{paginatedImages.map(({ src, name, description }, index) => (
  <motion.div
    key={index}
    className="relative w-full h-64 overflow-hidden rounded-lg shadow-lg group"
    whileHover={{ scale: 1.03 }}
  >
    <img
      src={src}
      alt={name}
      className="w-full h-full object-cover rounded-lg transition-transform duration-300"
    />
    
    {/* Bottom Overlay: Always Visible */}
    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-40 group-hover:bg-opacity-70 transition-all duration-300 p-3 text-white rounded-b-lg">
      <h3 className="text-sm font-semibold">{name}</h3>
      <p className="text-xs">{description}</p>
    </div>
  </motion.div>
))}
            </motion.div>
          </AnimatePresence>
        </div>
      </section>
    </div>
  );
}
